import {useAuth} from "base/auth";

import {EntityGeneralDataSection} from "base/entity";

const BombeoGeneralDataSection = ({bombeo}) => {
    const {ROLES} = useAuth();

    const sections = [
        {label: "Código", value: bombeo.codigo},
        {
            label: "Concello",
            value: bombeo.concello_label,
            linkPath: `/concellos/${bombeo.concello}`,
        },
        {
            label: "Aglomeración",
            value: bombeo.aglomeracion_label,
            linkPath: `/aglomeracions/${bombeo.aglomeracion}/summary`,
        },
        {
            label: "Titular", 
            value: bombeo.administracion_titular_label, 
            tooltipText: "Administración pública que ten a titularidade da infraestrutura dacordo os termos establecido na LEI 1/2022, do 12 de xullo, de mellora da xestión do ciclo integral da auga."
        },
        {label: "Notas", value: bombeo.notas},
    ];

    return (
        <>
            <EntityGeneralDataSection
                featured_image={bombeo.featured_image}
                featured_document={bombeo.featured_document}
                name={bombeo.nome || `Bombeo ${bombeo.codigo}`}
                sections={sections}
            />
        </>
    );
};

export default BombeoGeneralDataSection;
